import {
  CaseFindingPresentationType,
  FindingSource,
  GroupedFeature,
  MeasurementRangeInput,
  MeasurementUnits,
  QualifiedFeatureFragment,
  QualifiedFeatureInput,
  QualifiedFeatureQualifiers,
  Qualifier_Range,
  QualifierInput,
} from "../types";
import { AGE_RELATION_ID, RANGE_QUALIFIER_FEATURE_ID } from "./webDao";
import { WQualifiedFeature } from "@kahunmedical/common-wtypes";
import { WQualifier } from "@kahunmedical/common-wtypes/src/types";

export const asGroupedFeature = (
  group: CaseFindingPresentationType,
  source: FindingSource = FindingSource.Physician,
) => (qf: QualifiedFeatureFragment) =>
  ({
    source,
    group,
    feature: asQualifiedFeatureInput(qf),
    skip: qf.skip,
  } as GroupedFeature);

export function asQualifiedFeatureInput(
  finding: Partial<QualifiedFeatureFragment>,
): QualifiedFeatureInput {
  let feature = finding.feature.id;
  let alias = finding.feature.alias;
  let qualifiers = finding.qualifiers
    ? finding.qualifiers.map(asQualifierInput)
    : [];
  let negate = finding.negate;
  return {
    feature,
    alias,
    qualifiers,
    negate,
  };
}

function asMeasurementRangeInput(r: Qualifier_Range): MeasurementRangeInput {
  return {
    low: r.low,
    high: r.high,
    units: r.units,
    complexUnits: r.complexUnits
      ? {
          denominator: r.complexUnits.denominator,
          numerator: r.complexUnits.numerator,
        }
      : null,
  };
}

function asQualifierInput(q: QualifiedFeatureQualifiers): QualifierInput {
  return {
    relation: q.relation.id,
    value:
      (q.value && q.value.id) ||
      (q.relation.id === AGE_RELATION_ID ? RANGE_QUALIFIER_FEATURE_ID : null),
    negate: q.negate,
    range: q.range ? asMeasurementRangeInput(q.range) : null,
    freeText: q.freeText,
  };
}

function asQualifierInputFromW(wq: WQualifier): QualifierInput {
  return {
    relation: wq.relation.id,
    value: wq.feature && wq.feature.id,
    negate: wq.negate,
    range: wq.range && {
      low: wq.range?.low,
      high: wq.range?.high,
      // @ts-ignore
      units: wq.range?.units as MeasurementUnits,
    },
  };
}

export function asQualifiedFeatureInputFromW(
  wfinding: WQualifiedFeature,
): QualifiedFeatureInput {
  let feature = wfinding.feature.id;
  let qualifiers = wfinding.qualifiers
    ? wfinding.qualifiers.map(asQualifierInputFromW)
    : [];
  let negate = wfinding.negate;
  return {
    feature,
    qualifiers,
    negate,
  };
}
